<template>
  <div class="upload-material">
    <div class="upload-item" :class="{ 'disabled': disabled, 'have-img': innerValue, 'is-pdf': fileType === 'pdf' }" v-loading="loading">
      <!-- 有图片链接 -->
      <div v-if="innerValue">
        <!-- 上传好的图片 -->
        <div class="uploaded upload-box">
          <a v-if="fileType === 'pdf'" class="img-nav" target="_blank" :href="innerValue">
            <img src="../../../../../../assets/imgs/pdf.png" @drop="uploadDragImg($event, true)" @dragover="dragover" class="img">

            <div class="img-name-nav">
              <div :title="fileName" class="img-name">{{fileName}}</div>
            </div>
          </a>

          <img v-else :src="innerValue" @drop="uploadDragImg($event, true)" @dragover="dragover" class="img" v-viewer>
        </div>

        
        <slot :upload-input-id="uploadInputId"></slot>
      </div>

      <!-- 只有空的上传才可以是多选 -->
      <input ref="uploadInput" type="file" :id="uploadInputId" class="faraway-left" :accept="supportType" :multiple="uploadConfig.isMulti && !innerValue" @change="doUploadFile">

      <!-- 空的上传 -->
      <div class="upload-box" v-if="!innerValue">
        <div class="tip forbid-tip" v-if="disabled">
          <img v-if="disabled" src="../../../../../../assets/imgs/upload/forbid.png">
          <div class="tip-text">点击或拖拽上传</div>
        </div>

        <label @dragover="dragover" :for="uploadInputId" @drop="uploadDragImg" class="tip valid-tip" v-else>
          <img v-if="!disabled" src="../../../../../../assets/imgs/upload/upload.png">
          <div class="tip-text">点击或拖拽上传</div>
        </label>
      </div>
    </div>

  </div>
</template>

<script>
import utils from '@/libs/utils';
import imageService from '@/services/image-service';


export default {
  props: {  
    loading: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
    fileName: {
      type: String,
      default: '',
    }, 
    uploadConfig: {
      type: Object,
      default: () => ({
        pdf: false, // 是否需要上传pdf
        isMulti: false, // 是否支持新增多选
      }),
    },
    // 上传图片大小
    maxSize: {
      type: Number,
      default: 2 * 1024 * 1024,
    },
    disabled: {
      // 是否禁用
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      uploadInputId: `input-${utils.ranString(10)}`,
    };
  },
  computed: {
    innerValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    // 支持的上传文件类型
    supportType() {
      return this.uploadConfig.pdf ? 'application/pdf, image/jpeg, image/jpg, image/png' : 'image/jpeg, image/jpg, image/png';
    },

    fileType() {
      const url = this.innerValue || '';
      if (url) {
        const z = url.split('?')[0];
        if (z.split('.').indexOf('pdf') > -1) {
          return 'pdf';
        }
      }
    },
  },
  methods: {
    // 取消拖拽默认事件
    dragover(e) {
      e.preventDefault();
    },

    // 拖拽上传
    uploadDragImg(e, uploaded) {
      e.preventDefault();
      if (!uploaded) {
        const input = e.dataTransfer;// 获取到第一个上传的文件对象
        this.uploadFile(input);
      }
    },

    // 上传操作
    async uploadFile(img) {
      if (!img.files || !img.files[0]) return;
      const arr = this.supportType.split(', ');
      const fileNameType = img.files[0].name.substring(img.files[0].name.lastIndexOf('.') + 1).toLowerCase();
      if (arr.indexOf(img.files[0].type) === -1) {
        utils.msg.error('不支持上传该类型文件!');
        return;
      }
      if (arr.filter(type => type.indexOf(fileNameType) > -1).length === 0) {
        utils.msg.error('不支持上传该类型文件!');
        return;
      }

      // 转为真正的数组
      const filesArr = Array.from(img.files);
      // 文件尝试压缩，压缩之后还是大于指定大小则提示
      const compressFilePromise = filesArr.map((file) => {
        if (file.name.indexOf('pdf') === -1 && file.size > this.maxSize) {
          return imageService.compressImage(file);
        }
        return Promise.resolve(file);
      });
      const compressFiles = await Promise.all(compressFilePromise);
      
      if (compressFiles.some(file => file.name.indexOf('pdf') === -1 && file.size > this.maxSize)) {
        utils.msg.error(`图片大小不能超过${this.maxSize / 1024 / 1024}M，请重新选!`);
        return; 
      }

      // 解决IE11下input(file)change方法会执行两遍。第二遍file为null
      if (!(img.files && img.files.length > 0)) return;
      this.$emit(
        'uploadFile',
        this.uploadConfig.isMulti ? compressFiles : [compressFiles[0]],
      );
      this.$refs.uploadInput.value = null;
    },

    // 点击上传资料
    doUploadFile(e) {
      const input = e.target;
      this.uploadFile(input);
    },

  },
};
</script>

<style lang="less" scoped>
@import "../../../../../../assets/less/variable.less";
.upload-material {
  width: 100%;
  height: 100%;
}
.upload-item {
  width: 100%;
  height: 100%;
  border: 1px solid @main;
  border-radius: 4px;
  background-color: rgba(94, 155, 225, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  &.disabled {
    background-color: @active;
    border: 1px solid @border;
    .tip-text {
      color: @text-light-gray !important;
      cursor: default;
    }
  }
  &.have-img {
    border: 1px solid #f0f0f0;
    &.is-pdf {
       border: none;
    }
  }
  &:hover .delete {
    top: 5px;
  }
  &:hover .reupload {
    bottom: 0;
  }
  .faraway-left {
    position: absolute;
    left: -99999px; // 不能写top，直接平移到左边，不然点击之后会往上跳
  }
  .uploading {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 3;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .upload-box {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .uploaded {
    width: 100%;
    height: 100%;
    position: relative;
    .img-nav {
      width: 100%;
      height: 100%;
      position: relative;
      .img-name-nav {
        text-align: center;
        position: absolute;
        top: 50%;
        left: 50%;
        padding: 3px;
        background-color: #ffffff;
        transform: translate(-50%, -50%);
        z-index: 3;
        max-width: calc(100% - 10px);
      }
      .img-name {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        z-index: 1;
        font-size: 14px;
        color: #777;
        padding: 7px 10px;
        font-size: 14px;
        color: #6f6f6f;
        background-color: #ffffff;
        border: solid 1px rgba(94, 155, 225, 0.5);
      }
    }
    .img {
      max-width: 100%;
      width: 100%;
      position: relative;
      z-index: 1;
      cursor: pointer;
    }
  }
  .delete {
    position: absolute;
    right: 5px;
    top: -31px;
    display: flex;
    z-index: 3;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    width: 56px;
    height: 26px;
    color: white;
    transition: top 0.5s;
    font-size: 12px;
    background-color: rgba(0, 0, 0, 0.6);
    span {
      margin-left: 4px;
    }
  }
  .reupload {
    position: absolute;
    left: 0;
    bottom: -30px;
    display: block;
    display: flex;
    cursor: pointer;
    z-index: 3;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 14px;
    width: 100%;
    height: 30px;
    transition: bottom 0.5s;
    background-color: rgba(94, 155, 225, 0.9);
    &.bg-red {
      background-color: rgba(244, 51, 68, 0.9);
    }
    &.bottom-0 {
      bottom: 0;
      background-color: @text-red;
    }
    .reupload-item {
      position: relative;
      float: left;
      width: 50%;
      text-align: center;
      cursor: pointer;
    }
    .reupload-item + .reupload-item::before {
      content: '';
      position: absolute;
      top: -2px;
      left: 0;
      width: 1px;
      height: 18px;
      background-color: white;
    }
  }
  .verify-cover {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 2;
    .cover-img {
      position: absolute;
      right: 0;
      top: 0;
    }
  }
  .verify-passed {
    background-color: rgba(0, 0, 0, .3);
  }
  .verify-not-pass {
    background-color: rgba(0, 0, 0, 0.5);
  }
  .tip {
    line-height: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    &:hover img {
      opacity: 0.8;
    }
    &:hover .tip-text {
      opacity: 0.8;
    }
    &.valid-tip {
      cursor: pointer;
    }
    img {
      width: 36px;
      height: 36px;
    }
    .tip-text {
      text-align: left;
      margin-top: 10px;
      padding: 0 10px;
      color: #5e9be1;
      font-size: 12px;
      line-height: 16px;
      .drag-text {
        color: #aaa;
      }
    }
  }
}
#preview-img-box {
    // 这里部分样式是为了覆盖 add-order.vue（或其它文件中） 中对 el-dialog 设置的样式
    .el-dialog {
      z-index: 3000 !important;
      position: absolute;
      left: 50%;
      top: 15% !important;
      width: 50%;
      -webkit-transform: translateX(-50%);
      transform: translateX(-50%);
      background: #fff;
      border-radius: 2px;
    }
    .el-dialog__header {
      display: block;
    }
    .el-dialog__body {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 30px 20px;
      img {
        max-width: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/orders/reject-product-applicant/components/upload-reject-material-list/components/upload-material.vue